<template> 
<v-card hover="" width="100%" :color="color" flat="" tile=""  >
    <v-layout v-if="show"  width="100%">
        <vue-glide class="ma-0" 
            type="carousel"
            :perView="itemsPerPage"
            :autoplay="1000"
            :keyboard="true">
                <vue-glide-slide  class="ma-0" 
                    v-for="(item, index) in items" 
                    :key="index">  
                    <v-hover v-slot:default="{ hover }">  
                        <img class="mx-2"  :height="height" :src="item.path" />  
                    </v-hover>   
                </vue-glide-slide>  
        </vue-glide>
    </v-layout> 
    <v-sheet :height="height" v-else>
        <mbs-page-spinner
            :color="'primary lighten-2'"
            :width="5"
            :size="(height-20)"/> 
    </v-sheet>
</v-card>
</template>

<script> 
    export default {
        props:['height','color','opacity','title','text','items','itemsPerPage',],
        data(){
            return{
                show:true,   
            }
        },
        created(){ 
        },
        mounted(){   
        },
        computed:{
              
        },
        methods:{ 
        },
        watch:{ 
            itemsPerPage(v){
                this.show = false
                setTimeout(() => {
                    this.show = true
                }, 500);
                console.log(v);
            }
        } 

    }
</script>
<style>
  
</style> 